export default __webpack_public_path__ + "static/MediaContentFour-d328b2df9b94226e7d81fa095dc49b0f.webp";